import { ActionTree } from 'vuex';
import axios from 'axios';
import { RootState } from '../types';
import {ActionLog, AuthResponse, AuthState} from './types';

export const actions: ActionTree<AuthState, RootState> ={
  authRequest: async ({commit, dispatch}, user) => {
    commit('authRequest');
    try {
      let resp = await axios({url: '/lk-api/user/auth', method: 'post', data: user})
      let authResponse: AuthResponse = resp.data
      localStorage.setItem('lk-username', decodeURI(user.username));
      localStorage.setItem('lk-incp', authResponse.changePassword.toString());
      localStorage.setItem('lk-moderation', JSON.stringify(authResponse.moderationSettings));
      localStorage.setItem('lk-isADUser', (!!authResponse.isADUser).toString());
      commit('authSuccess');
      commit('setChangePassword', authResponse.changePassword);
      commit('setModerationSettings', authResponse.moderationSettings);
      commit('setIsADUser', !!authResponse.isADUser);
      commit('setUsername', decodeURI(user.username));
      return resp
    } catch(error) {
      console.log(error);
      commit('authError', error);
      localStorage.removeItem('lk-username');
      localStorage.removeItem('lk-allowedPages');
      localStorage.removeItem('lk-incp');
      localStorage.removeItem('lk-moderation');
      localStorage.removeItem('lk-isADUser');
      throw error;
    }
  },
  authLogout: async ({commit, dispatch}) => {
    // Cookie HttpOnly — погасить её может только бэкенд, поэтому сначала запрос,
    // пока сессия ещё жива. __isRetryRequest глушит перехватчик 401 в App.vue:
    // при мёртвой сессии сам logout вернёт 401 и вызвал бы authLogout повторно.
    try {
      await axios.post('/lk-api/user/logout', null, { __isRetryRequest: true } as any);
    } catch (error) {
      console.error('Logout на бэкенде не выполнен', error);
    }
    commit('authLogout');
    localStorage.removeItem('lk-username');
    localStorage.removeItem('lk-allowedPages');
    localStorage.removeItem('lk-incp');
    localStorage.removeItem('lk-moderation');
    localStorage.removeItem('lk-isADUser');
    localStorage.removeItem('lk-lastUrl');
    sessionStorage.clear();
  },
  actionLog: async ({commit, dispatch}, data: ActionLog) => {
    try {
      const today = new Date();
      const date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
      const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      const actionDate: string = date + 'T' + time
      const actionUser: string = localStorage.getItem("lk-username") || '';
      const actionLog: ActionLog = {
        actionDate: actionDate,
        actionPage: data.actionPage,
        action: data.action,
        objectType: data.objectType,
        objectName: data.objectName,
        actionStatus: data.actionStatus,
        addititionalInfo: data.addititionalInfo,
      }
      await axios.post("/lk-api/actions", actionLog)
    } catch (error){
      console.error(error)
    }
  },
  regCodeSend: async ({commit, dispatch}, data) => {
    let resp = await axios({
      method: 'post',
      url: '/lk-api/reg/code/send',
      data
    })
    return resp;
  },
  regCodeCheck: async ({commit, dispatch}, data) => {
    let resp = await axios({
      method: 'post',
      url: '/lk-api/reg/code/check',
      data
    })
    return resp;
  },
  regEntityCreate: async ({commit, dispatch}, data) => {
    let resp = await axios({
      method: 'post',
      url: '/lk-api/reg/entity/create',
      data
    })
    return resp;
  },
  forgotPasswordSendLink: async ({commit, dispatch}, data) => {
    let resp = await axios({
      method: 'post',
      url: '/lk-api/partner_users/password_link',
      data
    })
    return resp;
  },
  forgotPasswordCheckLink: async ({commit, dispatch}, data) => {
    let resp = await axios({
      method: 'post',
      url: '/lk-api/user/info/password_link/check',
      data
    })
    return resp;
  },
  forgotPasswordReset: async ({commit, dispatch}, data) => {
    let resp = await axios({
      method: 'put',
      url: '/lk-api/user/info/password_reset',
      data
    })
    return resp;
  },
};
